// Real client projects
export const projects = [
  {
    id: "p-villa-kythira",
    category: "construction",
    in_progress: true,
    cover: "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/flqbpks4_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/flqbpks4_image.png",
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/6c6urll2_kyt%201.png",
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/mxllfd60_kyt%202.png",
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/0o3ui6x8_kyt%203.png",
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/ceanoorg_kyt%204.png",
    ],
    title_en: "Villa Kythira",
    title_el: "Βίλα Κύθηρα",
    location_en: "Kythira, Greece",
    location_el: "Κύθηρα, Ελλάδα",
    year: "2025",
    scope_en: "New build under construction — stone façade villa with private pool, pergola and landscaped grounds.",
    scope_el: "Νέα κατασκευή υπό εξέλιξη — πέτρινη βίλα με ιδιωτική πισίνα, πέργκολα και διαμορφωμένο περιβάλλοντα χώρο.",
  },
  {
    id: "p-vyronas",
    category: "renovation",
    secondary_categories: ["plumbing"],
    cover: "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/5i9qbhcs_IMG_2895.jpeg",
    images: [
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/5i9qbhcs_IMG_2895.jpeg",
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/nr82iwk3_IMG_2896.jpeg",
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/8jqkij7h_IMG_2897.jpeg",
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/fd42gdz6_IMG_2898.jpeg",
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/uqh3kt91_IMG_2899.jpeg",
    ],
    title_en: "Vyronas Apartment",
    title_el: "Διαμέρισμα Βύρωνας",
    location_en: "Vyronas, Athens",
    location_el: "Βύρωνας, Αθήνα",
    year: "2025",
    scope_en: "Full renovation — custom kitchen with olive-green cabinetry, parquet flooring, curved built-in furniture and refined drywall partitions.",
    scope_el: "Ολική ανακαίνιση — custom κουζίνα με ελαιόχρωμα ντουλάπια, παρκέ δάπεδα, καμπυλωτές εντοιχισμένες κατασκευές και φινετσάτες γυψοσανίδες.",
  },
  {
    id: "p-kaisariani",
    category: "renovation",
    secondary_categories: ["plumbing"],
    cover: "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/29da9j9s_IMG_2388.jpeg",
    images: [
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/29da9j9s_IMG_2388.jpeg",
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/xitqi077_IMG_2389.jpeg",
      "https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/nkrqt9bq_IMG_2390%20%281%29.jpeg",
    ],
    title_en: "Kaisariani Apartment",
    title_el: "Διαμέρισμα Καισαριανή",
    location_en: "Kaisariani, Athens",
    location_el: "Καισαριανή, Αθήνα",
    year: "2025",
    scope_en: "Full renovation & plumbing — modern kitchen with custom cabinetry and a clean, mosaic-tiled bathroom.",
    scope_el: "Ολική ανακαίνιση & υδραυλικά — σύγχρονη κουζίνα με custom ντουλάπια και καθαρό, με ψηφίδες, μπάνιο.",
  },
];

export const testimonials = [
  {
    quote_en: "MITROLLARI delivered our Pagrati apartment with absolute precision. Every detail — from plumbing to the marble finishes — is flawless.",
    quote_el: "Η MITROLLARI παρέδωσε το διαμέρισμά μας στο Παγκράτι με απόλυτη ακρίβεια. Κάθε λεπτομέρεια — από τα υδραυλικά μέχρι τα μάρμαρα — είναι άψογη.",
    author: "A. Konstantinou",
    role_en: "Private Client — Pagrati, Athens",
    role_el: "Ιδιώτης Πελάτης — Παγκράτι, Αθήνα",
  },
  {
    quote_en: "Professional, on-time, and engineered to the highest standard. They handled renovation and plumbing seamlessly.",
    quote_el: "Επαγγελματίες, συνεπείς και με την υψηλότερη ποιότητα. Ανακαίνιση και υδραυλικά υλοποιήθηκαν άψογα.",
    author: "M. Papadopoulou",
    role_en: "Architect — Athens",
    role_el: "Αρχιτέκτων — Αθήνα",
  },
  {
    quote_en: "Clean execution, beautiful design integration, and excellent communication from start to finish.",
    quote_el: "Καθαρή υλοποίηση, άρτια ένταξη στον σχεδιασμό και εξαιρετική επικοινωνία από την αρχή μέχρι το τέλος.",
    author: "D. Loukas",
    role_en: "Homeowner — Kythira",
    role_el: "Ιδιοκτήτης — Κύθηρα",
  },
];
